import { render } from "./BlogBodyComponent.vue?vue&type=template&id=07ece86d&scoped=true"
import script from "./BlogBodyComponent.vue?vue&type=script&lang=js"
export * from "./BlogBodyComponent.vue?vue&type=script&lang=js"

import "./BlogBodyComponent.vue?vue&type=style&index=0&id=07ece86d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ece86d"]])

export default __exports__